export const TRANSIT_TRANSLATIONS: Record<string, any> = {
  English: {
    title: 'Transit Search',
    highlightedText: 'Transit',
    description: 'Track upcoming planetary transits with quick date ranges and detailed progress.',
    rangeLabels: {
      '30': '30 Days',
      '60': '60 Days',
      '90': '90 Days',
      '365': '1 Year',
      custom: 'Custom',
    },
    starts: 'Starts',
    ends: 'Ends',
    transitProgress: 'Transit Progress',
    to: 'to',
    loading: 'Calculating planetary transits...',
    empty: 'No transits found in this date range.',
    loadError: 'Failed to load transits. Please try again.',
    retrogradeBadge: 'Retrograde',
  },
  Hindi: {
    title: 'गोचर खोज',
    highlightedText: 'गोचर',
    description: 'तेज़ समय-सीमा फिल्टर के साथ आने वाले ग्रह गोचर और उनकी प्रगति देखें।',
    rangeLabels: {
      '30': '30 दिन',
      '60': '60 दिन',
      '90': '90 दिन',
      '365': '1 वर्ष',
      custom: 'कस्टम',
    },
    starts: 'शुरुआत',
    ends: 'समाप्ति',
    transitProgress: 'गोचर प्रगति',
    to: 'से',
    loading: 'ग्रह गोचर निकाले जा रहे हैं...',
    empty: 'इस तारीख सीमा में कोई गोचर नहीं मिला।',
    loadError: 'गोचर लोड नहीं हो सके। कृपया फिर से प्रयास करें।',
    retrogradeBadge: 'वक्री',
  },
}

